import fetchClient from './fetchClient';
import { errorHandler } from "./utils";


const config = (isExternalPage: boolean) => {
    return {
        headers: {
            Authorization: "Bearer " + localStorage.getItem(isExternalPage ? "delivery-token" : "token"),
        },
    };
};

export const getDeliveryTours = async (isExternalPage: boolean) => {
    const res: any = await fetchClient.get("/delivery-tours?limit=100", config(isExternalPage)).catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const editDeliveryTour = async (id: string, data: any) => {
    const res = await fetchClient.put(`/delivery-tours/${id}`, data, config(false)).catch(errorHandler);
    return res.data;
};

export const deleteDeliveryTour = async (id: string) => {
    const res = await fetchClient.delete(`/delivery-tours/${id}`, config(false)).catch(errorHandler);
    return res.data;
}

export const createDeliveryTour = async (customer: any) => {
    const res = await fetchClient.post("/delivery-tours", customer, config(false)).catch(errorHandler);
    return res.data;
};
